export default function() {
  return {
    table: {
      data: [],
      columns: [
        {
          prop: "operate_time",
          label: this.$t("ffm_time")
        },
        {
          prop: "account_name",
          label: this.$t("ffm_user")
        },
        {
          prop: "operation",
          label: this.$t("ffm_operation")
        },
        {
          prop: "traveler_name",
          label: this.$t("ffm_traveler_name")
        }
      ]
    }
  };
}
